export function formatSubscriberCount(n) {
    return Number.isFinite(n) ? n.toLocaleString() : null;
}

// Abbreviated badge form, e.g. 5,890,119 -> "+5M", 8,400 -> "+8K". Floors
// (not rounds) to match the target design's "+31M" for 31,572,856. Below
// 1,000 there isn't a meaningful abbreviation, so the badge is hidden.
export function formatAbbreviatedSubscriberCount(n) {
    if (!Number.isFinite(n) || n < 1_000) return null;
    if (n >= 1_000_000) return `+${Math.floor(n / 1_000_000)}M`;
    return `+${Math.floor(n / 1_000)}K`;
}
